(function(){
"use strict";

function initFreeTools(root){
  if (!root || root.dataset.avInitialized === "true") return;
  root.dataset.avInitialized = "true";

"use strict";

/* The cards are static HTML. This script filters them in place; it never builds them.
   That keeps one source of truth and leaves every tool name and description crawlable. */

var VIEW_KEY   = "av_tools_view_owner";
var RECENT_KEY = "av_tools_recent_owner";
var NOUN       = "tool";
var NOUN_PL    = "tools";
var IDLE_LABEL = "for pet owners";
var SLUG_RE    = /^\/pages\/[a-z0-9-]+$/;

var elResults = root.querySelector("#avresults");
var elCount   = root.querySelector("#avcount");
var elEmpty   = root.querySelector("#avempty");
var elChips   = root.querySelector("#avchips");
var elRail    = root.querySelector("#avazrail");
var elQ       = root.querySelector("#avq");
var elClear   = root.querySelector("#avclear");
var elTog     = root.querySelector("#avviewtog");
var CARDS     = [].slice.call(elResults.querySelectorAll(".tool"));

var state = {q:"", cat:"all", view:"grid"};

function norm(s){ return String(s==null?"":s).toLowerCase().replace(/[^a-z0-9 ]/g," ").replace(/\s+/g," ").trim(); }

CARDS.forEach(function(c){
  var ref = c.querySelector(".ref");
  c._cat = c.getAttribute("data-cat") || "";
  c._ltr = c.getAttribute("data-letter") || "#";
  c._hay = norm([
    c.querySelector("h3").textContent,
    c.querySelector("p").textContent,
    ref ? ref.textContent : "",
    c.getAttribute("data-kw") || ""
  ].join(" "));
  c._pending = c.classList.contains("pending");
  c._href = c.getAttribute("href");
  c._name = c.querySelector("h3").textContent.trim();
  if(c._pending) c.addEventListener("click", function(e){ e.preventDefault(); });
  else c.addEventListener("click", function(){ remember(c._href, c._name); });
});

/* ---- radiogroup: one tab stop, arrow keys (WAI-ARIA APG) ---- */
function wireRadioGroup(container, onSelect){
  function items(){ return Array.prototype.slice.call(container.children); }
  function select(btn, focus){
    items().forEach(function(b){
      var on = b === btn;
      b.setAttribute("aria-checked", on ? "true" : "false");
      b.tabIndex = on ? 0 : -1;
    });
    if(focus) btn.focus();
    onSelect(btn);
  }
  container.addEventListener("click", function(e){
    var btn = e.target.closest("button");
    if(btn && container.contains(btn)) select(btn, false);
  });
  container.addEventListener("keydown", function(e){
    var list = items(), i = list.indexOf(document.activeElement);
    if(i === -1) return;
    var next = null;
    if(e.key === "ArrowRight" || e.key === "ArrowDown") next = list[(i+1) % list.length];
    else if(e.key === "ArrowLeft" || e.key === "ArrowUp") next = list[(i-1+list.length) % list.length];
    else if(e.key === "Home") next = list[0];
    else if(e.key === "End") next = list[list.length-1];
    if(next){ e.preventDefault(); select(next, true); }
  });
  return select;
}

wireRadioGroup(elChips, function(btn){ state.cat = btn.getAttribute("data-cat"); apply(true); });

function matches(c){
  if(state.cat !== "all" && c._cat !== state.cat) return false;
  if(!state.q) return true;
  var terms = state.q.split(" ");
  for(var i=0;i<terms.length;i++){ if(c._hay.indexOf(terms[i]) === -1) return false; }
  return true;
}

function apply(userAction){
  var shown = 0, soon = 0, seen = {};
  CARDS.forEach(function(c){
    var ok = matches(c);
    c.hidden = !ok;
    c.removeAttribute("data-first");
    if(ok){
      if(c._pending) soon++; else shown++;
      if(!seen[c._ltr]){ seen[c._ltr] = true; c.setAttribute("data-first", c._ltr); c.id = "ltr-"+c._ltr; }
      else if(c.id.indexOf("ltr-") === 0){ c.removeAttribute("id"); }
    } else if(c.id.indexOf("ltr-") === 0){ c.removeAttribute("id"); }
  });
  var total = shown + soon;
  var g = elResults.querySelector(".grid");
  if(g) g.classList.toggle("allhidden", total === 0);
  var lastVis = null;
  CARDS.forEach(function(c){ c.classList.remove("lastvis"); if(!c.hidden) lastVis = c; });
  if(lastVis) lastVis.classList.add("lastvis");
  elEmpty.style.display = total ? "none" : "block";
  var filtering = (state.cat !== "all") || !!state.q;
  var label = "<strong>"+shown+"</strong> "+(shown===1?NOUN:NOUN_PL)+(filtering ? " shown" : " "+IDLE_LABEL);
  if(soon) label += " \u00b7 "+soon+" coming soon";
  elCount.innerHTML = label;
  buildRail(seen);
  elClear.style.display = elQ.value ? "block" : "none";
  if(userAction) keepInView();
}

/* The filter bar is sticky, so the controls stay on screen while the results may not. */
function keepInView(){
  if(window.scrollY === 0) return;            /* fresh page: leave the hero alone */
  var target = elEmpty.style.display === "block" ? elEmpty : elResults;
  var top = target.getBoundingClientRect().top;
  if(top < 0 || top > window.innerHeight) target.scrollIntoView({block:"start"});
}

function buildRail(seen){
  elRail.innerHTML = "";
  var letters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");
  if(seen["#"]) letters.unshift("#");
  letters.forEach(function(L){
    var a = document.createElement("a");
    a.textContent = L;
    if(seen[L]){ a.href = "#ltr-"+L; a.setAttribute("aria-label","Jump to "+L); }
    else { a.className = "off"; a.setAttribute("aria-hidden","true"); }
    elRail.appendChild(a);
  });
}

var tmr;
elQ.addEventListener("input", function(){
  clearTimeout(tmr);
  tmr = setTimeout(function(){ state.q = norm(elQ.value); apply(true); }, 90);
});
elQ.addEventListener("keydown", function(e){
  if(e.isComposing || e.keyCode === 229) return;
  if(e.key === "Escape"){ e.preventDefault(); clearTimeout(tmr); elQ.value=""; state.q=""; apply(false); }
});
elClear.addEventListener("click", function(){ clearTimeout(tmr); elQ.value=""; state.q=""; apply(false); elQ.focus(); });
root.querySelector("#avreset").addEventListener("click", function(){
  clearTimeout(tmr); elQ.value=""; state.q=""; state.cat="all";
  Array.prototype.forEach.call(elChips.children, function(b,i){
    b.setAttribute("aria-checked", i===0?"true":"false"); b.tabIndex = i===0?0:-1;
  });
  apply(false); elQ.focus();
});
document.addEventListener("keydown", function(e){
  if(e.key !== "/" || e.metaKey || e.ctrlKey || e.altKey || e.isComposing) return;
  var ae = document.activeElement;
  if(!ae || ae === elQ || ae.isContentEditable) return;
  if(/^(INPUT|TEXTAREA|SELECT)$/.test(ae.tagName)) return;
  e.preventDefault(); elQ.focus();
});

wireRadioGroup(elTog, function(btn){
  state.view = btn.getAttribute("data-view");
  try{ localStorage.setItem(VIEW_KEY, state.view); }catch(e){}
  elResults.className = (state.view === "list") ? "aslist" : "";
});
try{
  var sv = localStorage.getItem(VIEW_KEY);
  if(sv === "list" || sv === "grid") state.view = sv;
}catch(e){}
elResults.className = (state.view === "list") ? "aslist" : "";
Array.prototype.forEach.call(elTog.children, function(b){
  var on = b.getAttribute("data-view") === state.view;
  b.setAttribute("aria-checked", on?"true":"false"); b.tabIndex = on?0:-1;
});

function readRecent(){
  try{
    var r = JSON.parse(localStorage.getItem(RECENT_KEY));
    if(!Array.isArray(r)) return [];
    return r.filter(function(x){
      return x && typeof x.u === "string" && typeof x.n === "string" && SLUG_RE.test(x.u);
    }).slice(0,5);
  }catch(e){ return []; }
}
function remember(u,n){
  try{
    if(!SLUG_RE.test(u||"")) return;
    var r = readRecent().filter(function(x){ return x.u !== u; });
    r.unshift({u:u, n:n});
    localStorage.setItem(RECENT_KEY, JSON.stringify(r.slice(0,5)));
  }catch(e){}
}
(function paintRecent(){
  var r = readRecent();
  if(!r.length) return;
  var row = root.querySelector("#avrecentrow");
  row.innerHTML = "";
  r.forEach(function(x){
    var a = document.createElement("a"); a.href = x.u; a.textContent = x.n; row.appendChild(a);
  });
  root.querySelector("#avrecents").style.display = "block";
})();

apply(false);

/* ---- integrity: the static cards are the source of truth; schema must match them ---- */
function integrityCheck(){
  var warn = function(m){ console.warn("[askavet] " + m); };
  try{
    var node = root.querySelector("#avldjson");
    if(!node){ warn("ld+json block not found"); return; }
    var g   = JSON.parse(node.textContent)["@graph"] || [];
    var faq = g.filter(function(n){ return n["@type"] === "FAQPage"; })[0];
    var il  = g.filter(function(n){ return n["@type"] === "ItemList"; })[0];
    var live = CARDS.filter(function(c){ return !c._pending; });

    var qs = [].map.call(root.querySelectorAll(".seo details.faq summary h3"), function(h){ return h.textContent.trim(); });
    var as = [].map.call(root.querySelectorAll(".seo details.faq > p"), function(p){ return p.textContent.replace(/™/g,"").replace(/\s+/g," ").trim(); });
    if(!faq || !Array.isArray(faq.mainEntity)) warn("FAQPage node missing or has no mainEntity array");
    else {
      if(faq.mainEntity.length !== qs.length) warn("FAQ drift: "+qs.length+" visible vs "+faq.mainEntity.length+" in schema");
      faq.mainEntity.forEach(function(m,i){
        if(m.name !== qs[i]) warn("FAQ question "+(i+1)+" drift: schema \""+m.name+"\" vs page \""+(qs[i]||"")+"\"");
        var t = ((m.acceptedAnswer && m.acceptedAnswer.text) || "").replace(/\s+/g," ").trim();
        if(t !== as[i]) warn("FAQ answer "+(i+1)+" drift: schema and page text differ");
      });
    }

    /* alphabetical order of the static cards */
    for(var i=1;i<CARDS.length;i++){
      if(norm(CARDS[i-1]._name) > norm(CARDS[i]._name))
        warn("cards out of alphabetical order: \""+CARDS[i-1]._name+"\" before \""+CARDS[i]._name+"\"");
    }
    /* letter attribute must match the name, and every card must carry real copy */
    CARDS.forEach(function(c){
      var k0 = norm(c._name).charAt(0);
      var want = /[a-z]/.test(k0) ? k0.toUpperCase() : "#";
      if(c._ltr !== want) warn("data-letter on \""+c._name+"\" is "+c._ltr+", expected "+want);
      if(!/^[A-Z]$/.test(c._ltr)) warn("card \""+c._name+"\" has letter \""+c._ltr+"\", which the A-Z rail cannot reach");
      if(!c._name) warn("a card has an empty heading");
      var d = c.querySelector("p").textContent.trim();
      if(d.length < 40) warn("card \""+c._name+"\" has little or no description text ("+d.length+" chars) - that copy is the crawlable content");
      if(!c._pending && !/^\/pages\/[a-z0-9-]+$/.test(c._href || "")) warn("card \""+c._name+"\" has a bad href: "+c._href);
    });

    if(!il || !Array.isArray(il.itemListElement)) warn("ItemList node missing or has no itemListElement array");
    else {
      if(il.itemListElement.length !== live.length) warn("ItemList drift: "+live.length+" live cards vs "+il.itemListElement.length+" in schema");
      if(il.numberOfItems !== live.length) warn("numberOfItems drift: "+il.numberOfItems+" vs "+live.length+" live cards");
      il.itemListElement.forEach(function(x,i){
        if(x.position !== i+1) warn("ItemList position "+(i+1)+" is declared as "+x.position);
        var c = live[i];
        if(!c) return;
        if(x.name !== c._name) warn("ItemList order/name drift at position "+(i+1)+": schema \""+x.name+"\" vs card \""+c._name+"\"");
        var schemaPath;
        try{ schemaPath = new URL(x.url).pathname; }catch(e){ schemaPath = null; }
        if(schemaPath !== c._href) warn("ItemList url at position "+(i+1)+" resolves to "+schemaPath+", card points at "+c._href+" (full: "+x.url+")");
        if(x.item && x.item.url && x.item.url !== x.url) warn("ItemList item.url disagrees with url at position "+(i+1));
      });
    }
  }catch(e){ console.warn("[askavet] integrity check failed:", e); }
}
if(document.readyState === "loading") document.addEventListener("DOMContentLoaded", integrityCheck);
else integrityCheck();


}

function initAll(){
  document.querySelectorAll("[data-av-free-tools]").forEach(initFreeTools);
}

if(document.readyState === "loading") document.addEventListener("DOMContentLoaded", initAll);
else initAll();

document.addEventListener("shopify:section:load", function(event){
  var root = event.target.querySelector ? event.target.querySelector("[data-av-free-tools]") : null;
  if(root) initFreeTools(root);
});
})();
